import React from 'react';
import { PictogramContainer, Title, IconImg, Text, PictogramLink, } from '@@Components/Pictograms/Pictogram/styled';
export const Pictogram = ({ id, title, text, src, link, height, width, onClick = () => { }, }) => {
    return (React.createElement(PictogramContainer, { onClick: () => onClick(id) },
        React.createElement(PictogramLink, { href: link },
            React.createElement(IconImg, { src: src, alt: title, title: title, loading: "lazy", height: height, width: width }),
            React.createElement(Title, null, title)),
        React.createElement(Text, null, text)));
};
